import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const PortalsPlatformDataContext = /*#__PURE__*/createContext(undefined);
export function PortalsPlatformDataProvider({
  children,
  portalData
}) {
  return /*#__PURE__*/_jsx(PortalsPlatformDataContext.Provider, {
    value: portalData,
    children: children
  });
}
export function usePortalsPlatformData() {
  const context = useContext(PortalsPlatformDataContext);
  if (context === undefined) {
    throw new Error('usePortalsPlatformData must be used within a PortalsPlatformDataProvider');
  }
  return context;
}
export function useBrandSettings() {
  var _portalPlatformData$c;
  const portalPlatformData = usePortalsPlatformData();
  return portalPlatformData === null || portalPlatformData === void 0 || (_portalPlatformData$c = portalPlatformData.context) === null || _portalPlatformData$c === void 0 ? void 0 : _portalPlatformData$c.brandSettings;
}